import react from "react";
import "../app.css";
   
    function CalcIn(v) {
        
        return (
            <div className="CalcIn">
                <label htmlFor="CalcIn" >{v.name}</label>
                <input id="CalcIn" type={v.type} onChange={(event) => {v.holder(Number(event.target.value))}}/>

            </div>
        )
    }
    export default CalcIn